var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.328a.993.993 0 1 0 0-1.99.993.993 0 1 0 0 1.99zm8 0a.993.993 0 1 0 0-1.99.993.993 0 1 0 0 1.99zm8 0a.993.993 0 1 0 0-1.99.993.993 0 1 0 0 1.99z",
    fill: "#6D6D6D",
    stroke: "#6D6D6D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoButton);
export default __webpack_public_path__ + "static/media/info-button.34c510f52a48fa7d6b3132ce49461662.svg";
export { ForwardRef as ReactComponent };